import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import PageShell from '../components/ui/PageShell'
import Card from '../components/ui/Card'
import SectionTitle from '../components/ui/SectionTitle'

const linkClass = 'text-[#00d4aa] hover:underline'

export default function Datenschutz() {
  const location = useLocation()
  const isDashboard = location.pathname.startsWith('/dashboard')
  return (
    <PageShell>
      <div className="max-w-3xl space-y-6">
        <SectionTitle title="Datenschutzerklärung" />
        <Card className="p-6 space-y-6 text-sm text-white/90">
          <p className="text-white/70">
            Diese Datenschutzerklärung informiert Sie über die Verarbeitung personenbezogener Daten im Rahmen des Dienstes „AI
            Mastering Studio“ (mastering.anwendungen.online) und erfüllt die Anforderungen der DSGVO sowie des TTDSG.
          </p>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">1. Verantwortliche Stelle</h2>
            <p>
              <strong>Marc Fischer Digital Solution NRW</strong>
              <br />
              Inhaber: Marc Fischer
              <br />
              Lärchenweg 9
              <br />
              50389 Wesseling
              <br />
              Deutschland
            </p>
            <p className="mt-2">
              Telefon:{' '}
              <a href="tel:+4922325509977" className={linkClass}>
                02232 / 5509977
              </a>
              <br />
              <span className="text-xs text-white/50">
                Die Rufnummer wird zunächst von einer KI entgegengenommen und bei Bedarf an einen Mitarbeiter weitergeleitet.
              </span>
              <br />
              E-Mail:{' '}
              <a href="mailto:kontakt@anwendungen.online" className={linkClass}>
                kontakt@anwendungen.online
              </a>
              <br />
              Website:{' '}
              <a href="https://digitalsolutionnrw.de" className={linkClass} target="_blank" rel="noopener noreferrer">
                digitalsolutionnrw.de
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">2. Welche Daten werden verarbeitet?</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                <strong>Kontodaten:</strong> E-Mail-Adresse, Passwort (verschlüsselt), optionale Benachrichtigungseinstellungen.
              </li>
              <li>
                <strong>Nutzungsdaten:</strong> hochgeladene Audiodateien und daraus erzeugte Dateien (Master, Berichte, Cover,
                Canvas), Metadaten (z.&nbsp;B. Titel, Genre), Credits und Transaktionshistorie.
              </li>
              <li>
                <strong>Zahlungsdaten:</strong> bei Kreditkäufen über Stripe (Zahlungsabwicklung beim Zahlungsdienstleister;
                wir speichern keine vollständigen Kartendaten).
              </li>
              <li>
                <strong>Technische Daten:</strong> Server-Logs (z.&nbsp;B. IP-Adresse, Zeitpunkt, Browser) im technisch
                erforderlichen Umfang.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">3. Zwecke und Rechtsgrundlagen</h2>
            <p>
              Die Verarbeitung erfolgt zur Bereitstellung des Dienstes (Vertragserfüllung bzw. vorvertragliche Maßnahmen, Art.&nbsp;6
              Abs.&nbsp;1 lit.&nbsp;b DSGVO), zur Erfüllung rechtlicher Verpflichtungen (Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;c DSGVO,
              z.&nbsp;B. steuerliche Aufbewahrung) und – soweit Sie eingewilligt haben – für optionale Mitteilungen (Art.&nbsp;6
              Abs.&nbsp;1 lit.&nbsp;a DSGVO). Server-Logs und Sicherheit beruhen auf Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO
              (berechtigtes Interesse an sicherem Betrieb).
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">4. Speicherdauer</h2>
            <p>
              Kontodaten und Inhalte bleiben gespeichert, solange Ihr Konto besteht. Nach Kontolöschung werden personenbezogene
              Daten und zugehörige Inhalte gelöscht, soweit keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
              Zahlungsbelege können steuerrechtlich länger aufbewahrt werden. Protokolldaten nur begrenzt.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">5. Empfänger und Auftragsverarbeiter</h2>
            <p>
              Zur Bereitstellung des Dienstes können Auftragsverarbeiter eingesetzt werden (Hosting in der EU, E-Mail-Versand).
              Für KI-gestützte Schritte (z.&nbsp;B. Analyse, Cover-Vorschläge) können Dienste Dritter (z.&nbsp;B. OpenAI)
              eingebunden werden; dabei werden nur die dafür erforderlichen Daten übermittelt. Zahlungen laufen über Stripe.
              Mit Auftragsverarbeitern bestehen Vereinbarungen nach Art.&nbsp;28 DSGVO. Bei Übermittlungen in Drittstaaten
              (z.&nbsp;B. USA) erfolgen geeignete Garantien (z.&nbsp;B. Standardvertragsklauseln) bzw. Ihre Einwilligung, soweit
              erforderlich.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">6. Hosting</h2>
            <p>
              Der Dienst wird auf Servern in der Europäischen Union betrieben. Beim Besuch werden Verbindungsdaten
              (einschließlich IP-Adresse) in Server-Logdateien verarbeitet (Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO).
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">7. Ihre Rechte (DSGVO)</h2>
            <p>Sie haben unter den gesetzlichen Voraussetzungen:</p>
            <ul className="list-disc pl-5 mt-2 space-y-1">
              <li>
                <strong>Auskunft</strong> (Art.&nbsp;15 DSGVO),
              </li>
              <li>
                <strong>Berichtigung</strong> (Art.&nbsp;16 DSGVO),
              </li>
              <li>
                <strong>Löschung</strong> (Art.&nbsp;17 DSGVO),
              </li>
              <li>
                <strong>Einschränkung der Verarbeitung</strong> (Art.&nbsp;18 DSGVO),
              </li>
              <li>
                <strong>Datenübertragbarkeit</strong> (Art.&nbsp;20 DSGVO),
              </li>
              <li>
                <strong>Widerspruch</strong> (Art.&nbsp;21 DSGVO),
              </li>
              <li>
                <strong>Beschwerde</strong> bei einer Aufsichtsbehörde (Art.&nbsp;77 DSGVO).
              </li>
            </ul>
            <p className="mt-3">
              Im Dienst können Sie unter <strong>Einstellungen → Datenschutz &amp; Ihre Rechte</strong> Daten exportieren und
              Ihr Konto löschen.
            </p>
            <p className="mt-3">
              Zuständige Aufsichtsbehörde u.&nbsp;a.:
              <br />
              <strong>Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen (LDI NRW)</strong>
              <br />
              Postfach 20 04 44, 40102 Düsseldorf
              <br />
              Telefon: +49&nbsp;211&nbsp;38424-0 · E-Mail: poststelle@ldi.nrw.de ·{' '}
              <a href="https://www.ldi.nrw.de" className={linkClass} target="_blank" rel="noopener noreferrer">
                www.ldi.nrw.de
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">8. Cookies und lokale Speicherung</h2>
            <p>
              Es werden technisch notwendige Speicherungen genutzt (z.&nbsp;B. Anmeldestatus im lokalen Speicher / Session), die
              für den Betrieb erforderlich sind (§&nbsp;25 Abs.&nbsp;2 TTDSG, Art.&nbsp;6 Abs.&nbsp;1 lit.&nbsp;f DSGVO). Es
              erfolgt kein Marketing-Tracking ohne Ihre Einwilligung.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">9. SSL-/TLS-Verschlüsselung</h2>
            <p>
              Diese Seite nutzt SSL-/TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie am „https://“ und am
              Schloss-Symbol in der Browserzeile.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">10. Widerspruch gegen Werbe-E-Mails</h2>
            <p>
              Der Nutzung der im Impressum veröffentlichten Kontaktdaten zur Übersendung nicht ausdrücklich angeforderter Werbung
              wird widersprochen.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold text-white mb-2">11. Änderungen</h2>
            <p>
              Diese Datenschutzerklärung kann angepasst werden. Wesentliche Änderungen werden bei Nutzung des Dienstes oder per
              E-Mail mitgeteilt, soweit zulässig.
            </p>
          </section>

          <p className="text-white/50 pt-4 border-t border-white/10 text-xs">
            Stand: August 2026. Fragen an{' '}
            <a href="mailto:kontakt@anwendungen.online" className={linkClass}>
              kontakt@anwendungen.online
            </a>
            .
          </p>
        </Card>
        <p className="text-center">
          <Link to={isDashboard ? '/dashboard' : '/'} className={linkClass}>
            ← {isDashboard ? 'Zum Dashboard' : 'Zur Startseite'}
          </Link>
        </p>
      </div>
    </PageShell>
  )
}
